/*
 * OfferServices Constants
 */

export const GET_SERVICES = 'ideal/OfferServices/GET_SERVICES';
export const SERVICES_RECEIVED = 'ideal/OfferServices/SERVICES_RECEIVED';
export const SERVICES_ERROR = 'ideal/OfferServices/SERVICES_ERROR';
export const SERVICE_SELECTED = 'ideal/OfferServices/SERVICE_SELECTED';
export const SET_OFFER_PRODUCT_SERVICES = 'ideal/OfferServices/SET_OFFER_PRODUCT_SERVICES';
export const RESET = 'ideal/OfferServices/RESET';
